import { render } from "./IFCFilesContainer.vue?vue&type=template&id=3dec540a&scoped=true"
import script from "./IFCFilesContainer.vue?vue&type=script&lang=js"
export * from "./IFCFilesContainer.vue?vue&type=script&lang=js"

import "./IFCFilesContainer.vue?vue&type=style&index=0&id=3dec540a&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dec540a"]])

export default __exports__